import { MecProduct } from '@adapters/bigcommerce/types/product';
import { MultiGroupPrices } from '@adapters/bigcommerce/operations/getAllCustomerGroupPrices';
import { ProductCompareConfig } from '_components/Product/ProductCompareTable/types';

export interface CompareSpec {
  en: string;
  fr: string;
}

const FIXED_SPEC_LABELS = [
  'Name',
  'Nom',
  'Price',
  'Prix',
  'Ideal For',
  'Idéal pour',
];

export function buildProductCompareConfig(
  specs: CompareSpec[],
  title: { en: string; fr: string },
  compareProductIds: string[],
  locale: string
): ProductCompareConfig {
  return {
    heading: {
      line1: title[locale as keyof typeof title] || 'N/A',
    },
    compareProductIds,
    attributes: specs
      .filter(
        (s) =>
          !FIXED_SPEC_LABELS.includes(s.en) && !FIXED_SPEC_LABELS.includes(s.fr)
      )
      .map((s) => ({ key: s.en, label: { en: s.en, fr: s.fr } })),
  };
}

export function buildGroupPricesByCode(
  product: MecProduct,
  customerGroupPrices: MultiGroupPrices | null,
  compareProductsGroupPrices: Record<string, MultiGroupPrices | null> | null
): Record<string, MultiGroupPrices | null> {
  return {
    ...(product.code ? { [product.code]: customerGroupPrices } : {}),
    ...(compareProductsGroupPrices ?? {}),
  };
}
